/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Modal, Fade, Backdrop, Button } from '@material-ui/core';

import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 18,
    margin: 0,
    color: '#1e3f9e',
    marginBottom: 25,
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    padding: '2rem',
    paddingTop: '1rem',
    width: '375px',
    textAlign: 'center',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 4,
    boxShadow: theme.shadows[5],
    outline: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  button: {
    width: '30%',
    padding: '0.6rem',
    color: 'white',
    backgroundColor: '#00d1b2',
    '&:hover': {
      backgroundColor: '#00bca0',
    },
  },
}));

const LogoutTimerModal = ({ open, setOpen }) => {
  const classes = useStyles();
  const [seconds, setSeconds] = useState(120);

  useEffect(() => {
    let timer;
    if (open) {
      setSeconds(120);
      timer = setInterval(() => {
        setSeconds((sec) => sec - 1);
      }, 1000);
    } else {
      clearInterval(timer);
    }
    return () => {
      clearInterval(timer);
    };
  }, [open]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
    >
      <Fade in={open}>
        <div className={classes.paper}>
          <h2 className={classes.title}>You are About to be Logged Out</h2>
          <p>{`You have been idle too long and will be logged out in ${seconds} seconds if you do not take an action.`}</p>
          <Button className={classes.button} size="small" variant="contained" onClick={handleClose}>
            Continue
          </Button>
        </div>
      </Fade>
    </Modal>
  );
};

LogoutTimerModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
};

export default LogoutTimerModal;
